import React from "react";
import { Link } from "react-router-dom";

const Chapter = (chapter) => {
  return (
    <li className="col-span-1 flex shadow-sm rounded-md">
      <div className='bg-purple-600 flex-shrink-0 flex items-center justify-center w-16 text-white text-sm font-medium rounded-l-md'>
        {chapter.number}장
      </div>
      <div className="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate">
        <div className="flex-1 px-4 py-2 text-sm truncate">
          <Link to={`/chapters/${chapter.id}`} className="text-gray-900 font-medium hover:text-gray-600">
            {chapter.number}장
          </Link>
          <p className="text-gray-500">총 {chapter.versesCount}절</p>
        </div>
      </div>
    </li>
  );
};

export default Chapter;
